module.exports = __webpack_public_path__ + "img/GST.4b2d9db2.png";